import { render, staticRenderFns } from "./format-time.vue?vue&type=template&id=71ec1ecc&scoped=true"
import script from "./format-time.vue?vue&type=script&lang=js"
export * from "./format-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec1ecc",
  null
  
)

export default component.exports